/* E-note theme JS — smooth scroll, animations, AJAX cart. */
(function () {
  'use strict'

  document.addEventListener('DOMContentLoaded', init)

  function init() {
    if (window.gsap && window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger)
    initLenis()
    initNav()
    initMenu()
    initHero()
    initPageHead()
    initReveals()
    initCraftRows()
    initProductCards()
    initCartDrawer()
  }

  /* ——— Smooth scroll: 0.2s glide — just softens the edge, no perceptible lag ——— */
  function initLenis() {
    if (!window.Lenis || !window.gsap) return
    const lenis = new Lenis({
      duration: 0.2,
      easing: (t) => 1 - Math.pow(1 - t, 3),
      smoothWheel: true,
      wheelMultiplier: 1.15,
      touchMultiplier: 1.6,
    })
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time) => lenis.raf(time * 1000))
    gsap.ticker.lagSmoothing(0)
  }

  /* ——— Nav ——— */
  function initNav() {
    const nav = document.getElementById('site-nav')
    if (!nav) return
    let lastY = 0
    addEventListener('scroll', () => {
      const y = scrollY
      nav.classList.toggle('scrolled', y > 24)
      nav.classList.toggle('hidden', y > 420 && y > lastY && !document.body.classList.contains('menu-open'))
      lastY = y
    }, { passive: true })
  }

  function initMenu() {
    const btn = document.getElementById('menu-btn')
    const menu = document.getElementById('mobile-menu')
    const nav = document.getElementById('site-nav')
    if (!btn || !menu) return
    btn.addEventListener('click', () => {
      const open = !menu.classList.contains('open')
      menu.classList.toggle('open', open)
      btn.classList.toggle('open', open)
      btn.setAttribute('aria-expanded', open)
      menu.setAttribute('aria-hidden', !open)
      document.body.classList.toggle('menu-open', open)
      document.body.style.overflow = open ? 'hidden' : ''
      if (open) nav.classList.add('scrolled')
      // Stagger the links
      menu.querySelectorAll('nav a').forEach((a, i) => {
        a.style.transitionDelay = open ? 0.08 + i * 0.05 + 's' : '0s'
      })
    })
  }

  /* ——— Hero intro + parallax ——— */
  function initHero() {
    if (!window.gsap) return
    const hero = document.querySelector('.hero')
    if (!hero) return
    const tl = gsap.timeline({ defaults: { ease: 'power4.out' } })
    tl.fromTo('.hero .eyebrow', { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.15)
      .fromTo('.hero .line-mask > span', { yPercent: 110 }, { yPercent: 0, duration: 1.2, stagger: 0.12 }, 0.25)
      .fromTo('.hero .lede', { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9 }, 0.75)
      .fromTo('.hero-ctas', { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9 }, 0.9)
      .fromTo('.hero-visual', { y: 110, opacity: 0, scale: 0.96 }, { y: 0, opacity: 1, scale: 1, duration: 1.4, ease: 'power3.out' }, 0.95)
      .fromTo('.hero-chip', { y: 26, opacity: 0, scale: 0.9 }, { y: 0, opacity: 1, scale: 1, duration: 0.8, stagger: 0.14, ease: 'back.out(1.6)' }, 1.5)
      .fromTo('.scroll-cue', { opacity: 0 }, { opacity: 1, duration: 0.8 }, 1.8)

    gsap.to('.hero-visual', {
      y: -70, scale: 1.02, ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 1.2 },
    })
    gsap.to('.hero-headline', {
      y: -110, opacity: 0.25, ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: '60% top', scrub: 1.2 },
    })
    gsap.to('.hero-chip.tl', { y: '-=12', duration: 2.6, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 2.4 })
    gsap.to('.hero-chip.br', { y: '-=10', duration: 3.1, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 2.6 })

    const teaser = document.querySelector('.craft-teaser img')
    if (teaser) {
      gsap.to(teaser, {
        yPercent: 12, ease: 'none',
        scrollTrigger: { trigger: '.craft-teaser', start: 'top bottom', end: 'bottom top', scrub: 1.2 },
      })
    }
  }

  /* ——— Sub-page header intro ——— */
  function initPageHead() {
    if (!window.gsap) return
    const head = document.querySelector('.page-head .container')
    if (!head) return
    gsap.fromTo(head.children, { y: 34, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1, stagger: 0.12, ease: 'power3.out', delay: 0.15,
    })
  }

  /* ——— Generic scroll reveals (every major element animates in) ——— */
  function initReveals() {
    if (!window.gsap) return
    const selectors = [
      '[data-reveal]',
      '.section-head', '.shop-head',
      '.product-card', '.collection-card', '.value-card', '.trust-item', '.contact-card',
      '.enquiry-form', '.checkout-form', '.order-summary',
      '.story-copy p', '.story-sign',
      '.craft-teaser-copy > *',
      '.paper-section .eyebrow',
      '.product-single .product-media.standalone', '.product-single [data-product-card]',
      '.footer-grid > *',
    ]
    const seen = new Set()
    document.querySelectorAll(selectors.join(', ')).forEach((el) => {
      if (seen.has(el) || el.querySelector('.line-mask')) return
      seen.add(el)
      const siblings = el.parentElement ? [...el.parentElement.children] : [el]
      const idx = Math.max(0, siblings.indexOf(el))
      gsap.fromTo(el, { y: 48, opacity: 0 }, {
        y: 0, opacity: 1, duration: 1, delay: (idx % 4) * 0.08, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 90%', toggleActions: 'play none none reverse' },
      })
    })
    document.querySelectorAll('.line-mask > span').forEach((el) => {
      if (el.closest('.hero')) return
      gsap.fromTo(el, { yPercent: 110 }, {
        yPercent: 0, duration: 1.1, ease: 'power4.out',
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none reverse' },
      })
    })
  }

  /* ——— Craft page: alternating rows slide in from their side ——— */
  function initCraftRows() {
    if (!window.gsap) return
    document.querySelectorAll('.craft-row').forEach((row, i) => {
      const media = row.querySelector('.craft-row-media')
      const copy = row.querySelector('.craft-row-copy')
      const fromRight = i % 2 === 1
      if (media) {
        gsap.fromTo(media, { x: fromRight ? 70 : -70, opacity: 0 }, {
          x: 0, opacity: 1, duration: 1.1, ease: 'power3.out',
          scrollTrigger: { trigger: row, start: 'top 82%', toggleActions: 'play none none reverse' },
        })
      }
      if (copy) {
        gsap.fromTo(copy.children, { y: 34, opacity: 0 }, {
          y: 0, opacity: 1, duration: 0.9, stagger: 0.1, delay: 0.15, ease: 'power3.out',
          scrollTrigger: { trigger: row, start: 'top 82%', toggleActions: 'play none none reverse' },
        })
      }
    })
  }

  /* ——— Money ——— */
  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 })
  }

  /* ——— Fly-to-cart: product photo arcs from the clicked button into the cart ——— */
  function flyToCart(card, btn, onLand) {
    const land = () => { if (onLand) onLand() }
    if (!window.gsap || matchMedia('(prefers-reduced-motion: reduce)').matches) return land()
    const scope = card.closest('.product-single') || card
    const img = scope.querySelector('.product-media img.main') || scope.querySelector('.product-media img')
    const target = document.getElementById('cart-open')
    if (!img || !target) return land()

    // Make sure the cart icon is on screen even if the nav auto-hid while scrolling
    document.getElementById('site-nav')?.classList.remove('hidden')

    const size = 56
    const from = btn.getBoundingClientRect()
    const to = target.getBoundingClientRect()
    const startX = from.left + from.width / 2 - size / 2
    const startY = from.top + from.height / 2 - size / 2
    const endX = to.left + to.width / 2 - size / 2
    const endY = to.top + to.height / 2 - size / 2

    const wrap = document.createElement('div')
    wrap.style.cssText = 'position:fixed;left:0;top:0;z-index:200;pointer-events:none;will-change:transform'
    const fly = document.createElement('img')
    fly.src = img.currentSrc || img.src
    fly.alt = ''
    fly.style.cssText = 'display:block;width:' + size + 'px;height:' + size + 'px;border-radius:999px;object-fit:cover;border:2px solid #fff;background:#f6f1e8;box-shadow:0 12px 32px rgba(28,26,21,0.35)'
    wrap.appendChild(fly)
    document.body.appendChild(wrap)

    gsap.set(wrap, { x: startX, y: startY })
    gsap.fromTo(fly, { scale: 0.3, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.22, ease: 'back.out(2)' })
    gsap.to(wrap, { x: endX, duration: 0.75, ease: 'power1.inOut' })
    gsap.to(wrap, { y: Math.max(8, Math.min(startY, endY) - 60), duration: 0.3, ease: 'power2.out' })
    gsap.to(wrap, { y: endY, duration: 0.45, delay: 0.3, ease: 'power2.in' })
    gsap.to(fly, { scale: 0.2, duration: 0.35, delay: 0.4, ease: 'power2.in' })
    gsap.to(fly, {
      opacity: 0, duration: 0.12, delay: 0.68,
      onComplete: () => {
        wrap.remove()
        gsap.fromTo(target, { scale: 1.14 }, { scale: 1, duration: 0.45, ease: 'power2.out' })
        land()
      },
    })
  }

  /* ——— Product cards: variant chips + add to cart ——— */
  function initProductCards() {
    document.querySelectorAll('[data-product-card]').forEach((card) => {
      const jsonEl = card.querySelector('[data-product-json]')
      const addBtn = card.querySelector('[data-add-to-cart]')
      if (!jsonEl || !addBtn) return
      let data
      try { data = JSON.parse(jsonEl.textContent) } catch { return }

      const selection = []
      card.querySelectorAll('.opt-group').forEach((group) => {
        const idx = Number(group.dataset.optionIndex)
        const selected = group.querySelector('.opt-chip.selected') || group.querySelector('.opt-chip')
        if (selected) selected.classList.add('selected')
        selection[idx] = selected ? selected.dataset.optionValue : null

        group.querySelectorAll('.opt-chip').forEach((chip) => {
          chip.addEventListener('click', () => {
            group.querySelectorAll('.opt-chip').forEach((c) => c.classList.remove('selected'))
            chip.classList.add('selected')
            selection[idx] = chip.dataset.optionValue
            syncVariant()
          })
        })
      })

      function currentVariant() {
        return data.variants.find((v) => v.options.every((o, i) => o === selection[i]))
      }

      function syncVariant() {
        const v = currentVariant()
        const priceEl = card.querySelector('[data-price]')
        if (v) {
          addBtn.dataset.variantId = v.id
          addBtn.disabled = !v.available
          addBtn.style.opacity = v.available ? '' : '0.45'
          if (priceEl) priceEl.textContent = money(v.price)
        } else {
          addBtn.disabled = true
          addBtn.style.opacity = '0.45'
        }
      }
      syncVariant()

      addBtn.addEventListener('click', async (e) => {
        e.preventDefault()
        const id = Number(addBtn.dataset.variantId)
        if (!id) return
        addBtn.disabled = true
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 }),
          })
          if (!res.ok) throw new Error('add failed')
          addBtn.classList.add('just-added')
          setTimeout(() => addBtn.classList.remove('just-added'), 1200)
          toast('Added to cart')
          try {
            await refreshCart(false)
          } catch {
            // The add succeeded but the cart-state fetch failed — bump the badge locally
            const badge = document.getElementById('cart-badge')
            if (badge) {
              badge.textContent = (parseInt(badge.textContent, 10) || 0) + 1
              badge.hidden = false
            }
          }
          flyToCart(card, addBtn, () => {
            const badge = document.getElementById('cart-badge')
            if (badge) {
              badge.classList.remove('bump')
              void badge.offsetWidth
              badge.classList.add('bump')
            }
          })
        } catch {
          toast('Could not add — try again')
        }
        addBtn.disabled = false
      })
    })
  }

  /* ——— Cart drawer ——— */
  let drawer, overlay
  function initCartDrawer() {
    drawer = document.getElementById('cart-drawer')
    overlay = document.getElementById('cart-overlay')
    if (!drawer) return
    document.getElementById('cart-open')?.addEventListener('click', async () => {
      await refreshCart(false)
      openDrawer()
    })
    document.getElementById('cart-close')?.addEventListener('click', closeDrawer)
    overlay?.addEventListener('click', closeDrawer)
    addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer() })

    drawer.addEventListener('click', async (e) => {
      const stepBtn = e.target.closest('[data-qty-change]')
      const removeBtn = e.target.closest('[data-remove]')
      if (!stepBtn && !removeBtn) return
      const key = (stepBtn || removeBtn).dataset.key
      const qty = stepBtn ? Number(stepBtn.dataset.qtyChange) : 0
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
      await refreshCart(false)
    })
  }

  function openDrawer() {
    drawer.classList.add('show')
    overlay.classList.add('show')
    drawer.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
  }
  function closeDrawer() {
    if (!drawer) return
    drawer.classList.remove('show')
    overlay.classList.remove('show')
    drawer.setAttribute('aria-hidden', 'true')
    if (!document.body.classList.contains('menu-open')) document.body.style.overflow = ''
  }

  async function refreshCart(bump) {
    const res = await fetch('/cart.js')
    const cart = await res.json()

    const badge = document.getElementById('cart-badge')
    if (badge) {
      badge.hidden = cart.item_count === 0
      badge.textContent = cart.item_count
      if (bump) {
        badge.classList.remove('bump')
        void badge.offsetWidth
        badge.classList.add('bump')
      }
    }

    const itemsEl = document.getElementById('cart-items')
    const emptyEl = document.getElementById('cart-empty')
    const footEl = document.getElementById('cart-foot')
    if (!itemsEl) return

    if (cart.item_count === 0) {
      itemsEl.innerHTML = ''
      emptyEl.hidden = false
      footEl.hidden = true
      return
    }
    emptyEl.hidden = true
    footEl.hidden = false
    document.getElementById('cart-subtotal').textContent = money(cart.items_subtotal_price)

    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-item">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : ''}" alt="">
        <div>
          <div class="ci-name">${esc(item.product_title)}</div>
          <div class="ci-variant">${esc(item.variant_title || '')}</div>
          <div class="ci-price">${money(item.final_price)}</div>
        </div>
        <div class="ci-right">
          <div class="qty-stepper">
            <button data-qty-change="${item.quantity - 1}" data-key="${item.key}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button data-qty-change="${item.quantity + 1}" data-key="${item.key}" aria-label="Increase quantity">+</button>
          </div>
          <button class="ci-remove" data-remove data-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('')
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
  }

  /* ——— Toast ——— */
  let toastTimer
  function toast(msg) {
    const el = document.getElementById('toast')
    if (!el) return
    document.getElementById('toast-msg').textContent = msg
    el.classList.add('show')
    clearTimeout(toastTimer)
    toastTimer = setTimeout(() => el.classList.remove('show'), 2200)
  }
})()
